/** @format */

import React from 'react'

import { Row, Col } from 'antd'

import './style.css'

export default function OrderInfo(props) {
	return (
		<div className='ph-counter-order-detail-payment-data-container'>
			<div className='ph-counter-order-detail-payment-data-content'>
				<span className='ph-counter-order-detail-payment-data-id-order'>{props.id}</span>
				<h1 className='ph-counter-order-detail-payment-id'>Número de Órden</h1>
			</div>
			<div className='ph-counter-order-detail-payment-data-content'>
				<span className='ph-counter-order-detail-payment-data-id-token'>{props.code}</span>
				<h1 className='ph-counter-order-detail-payment-id'>Número de Código</h1>
			</div>
			<Row justify='center'>
				<Col lg={4}>
					<h1 className='ph-counter-order-detail-payment-id-status-title'>
						Status: <br />{' '}
						<strong className='ph-counter-order-detail-payment-id-status'>
							{props.status?.status || props.status}
						</strong>
					</h1>
				</Col>
				<Col lg={5}>
					<h1 className='ph-counter-order-detail-payment-id-status-title'>
						Respuesta: <br />{' '}
						<strong className='ph-counter-order-detail-payment-id-status'>00</strong>
					</h1>
				</Col>
			</Row>
			{props.status.status === 500 && (
				<h1 className='ph-counter-order-detail-payment-id-status-title'>
					Motivo de Rechazo: <br />{' '}
					<strong className='ph-counter-order-detail-payment-id-status'>
						{props.status.reason}
					</strong>
				</h1>
			)}
		</div>
	)
}
